import { LabelledEntity } from 'shared/types/commonView';
import { FiltersTranslationKeys } from 'intl/keys';
import type { IssueWorkflowOutDto } from 'shared/domain/workflow/types';
import { sortByProp } from 'helpers/sort';
import { useWorkflows } from 'store/workflow';
import { findStagesByWorkflowId } from 'store/workflow/model';
import { createEntityFilterInput } from '../common';

export const IssueStageFilterInput = createEntityFilterInput({
  useData: () => {
    const { workflows } = useWorkflows();
    return workflows;
  },
  transformData: (workflows: IssueWorkflowOutDto[]) => {
    const available = workflows.reduce<LabelledEntity[]>((acc, workflow) => {
      const group = workflow.name || '';
      const orderedStages = findStagesByWorkflowId(workflows, workflow._id);
      for (const stage of orderedStages) {
        acc.push({
          _id: stage._id,
          label: stage.name,
          group,
        });
      }
      return acc;
    }, []);

    return sortByProp(available, 'group') as LabelledEntity[];
  },
  labelId: FiltersTranslationKeys.filterTypeStage,
  id: 'issue-stage-filter',
  groupBy: (option: LabelledEntity) => option.group || '',
});
